/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

Odigeo.defineWidget('membership_subscription', Odigeo.Widget.extend({
    modelClass: require('./membership_subscription.model'),
    viewClass: require('./membership_subscription.view'),

    init: function() {
        this.listenTo(this.view, 'updateProduct', this.updateProduct);
    },

    alertDisclaimer: function(mustAppearDisclaimer) {
        this.view.alertDisclaimer(mustAppearDisclaimer);
    },

    checkPreviouslyAddedProduct: function() {
        this.view.checkPreviouslyAddedProduct();
    },

    deleteMembership: function() {
        this.view.deleteMembership();
    },

    getData: function() {
        this.view.trackContinueToPayment();
        return this.model.getData();
    },

    getGroup: function() {
        return this.view.getGroup();
    },

    getMemberClick: function() {
        return this.view.getMemberClick();
    },

    hideWidget: function(isUserLoggedIn) {
        this.view.hideWidget(isUserLoggedIn);
    },

    isSelected: function() {
        return this.model.isMemberSelected();
    },

    load: function() {
        this.model.refreshData();
    },

    openLightBox: function(mustAppearDisclaimer) {
        this.view.openLightBox(mustAppearDisclaimer);
    },

    renderLightBoxTemplate: function() {
        this.view.renderLightBoxTemplate();
    },

    setListOfTravellers: function(data) {
        this.model.setListOfTravellers(data);
    },

    loginDone: function(userDTO) {
        this.logBehaviour(userDTO);
    },

    logoutDone: function() {
        this.logBehaviour();
    },

    logBehaviour: function(userDTO) {
        let isLoggedIn = !Odigeo._.isUndefined(userDTO);
        this.model.set('userDTO', userDTO);
        this.model.set('isUserLoggedIn', isLoggedIn);
        this.view.showLoginLink(isLoggedIn);
        this.view.updateState(isLoggedIn);
    },

    showWidget: function() {
        this.view.showWidget();
    },

    solveAddMembershipError: function(error) {
        this.view.solveAddMembershipError(error);
    },

    trackGetMembershipLightBox: function(trackingType, dataToUse) {
        this.view.trackGetMembershipLightBox(trackingType, dataToUse);
    },

    updateProduct: function(action) {
        this.model.updateProduct(action);
    },
}));
